import React from 'react';
import { tokens } from '../../theme/tokens';

const BUBBLE =
  'M10 5h20a7 7 0 0 1 7 7v11a7 7 0 0 1-7 7H19l-7.5 6.2V30H10a7 7 0 0 1-7-7V12a7 7 0 0 1 7-7z';
const SMILE = 'M15 22.5c2.8 2.3 7.2 2.3 10 0';

interface FinMarkProps {
  size?: number;
  /** "inverse" is the white bubble used on the dark petrol background. */
  variant?: 'default' | 'inverse';
}

/** Fin, the Financy assistant: a speech bubble with a face. */
const FinMark: React.FC<FinMarkProps> = ({ size = 32, variant = 'default' }) => {
  const bubble = variant === 'inverse' ? '#FFFFFF' : tokens.accent;
  const face = variant === 'inverse' ? tokens.accentDeep : '#FFFFFF';
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 40 40'
      aria-hidden='true'
      style={{ flexShrink: 0, display: 'block' }}
    >
      <path d={BUBBLE} fill={bubble} />
      <circle cx='15' cy='16.5' r='2.4' fill={face} />
      <circle cx='25' cy='16.5' r='2.4' fill={face} />
      <path
        d={SMILE}
        fill='none'
        stroke={face}
        strokeWidth='2.2'
        strokeLinecap='round'
      />
    </svg>
  );
};

/** The same mark as a data URI, for the center of the QR code. */
export const finMarkDataUri = `data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="${BUBBLE}" fill="${tokens.accent}"/><circle cx="15" cy="16.5" r="2.4" fill="#fff"/><circle cx="25" cy="16.5" r="2.4" fill="#fff"/><path d="${SMILE}" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`
)}`;

export default FinMark;
